import Vue from 'vue'
import App from './App.vue'
import store from './store'
import VueI18n from 'vue-i18n'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [
  { path: '/view/:key', name: 'view' },
  { path: '/', name: 'default' }
]
const router = new VueRouter({
  routes: routes,
  mode: 'history',
  base: process.env.BASE_URL
})

Vue.config.productionTip = false

const I18nMessages = require('./messages.json')
Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'ja',
  messages: I18nMessages
})
// $tメソッドをオーバーライド
const originalT = i18n.t.bind(i18n)

function getNestedValue (obj, path) {
  // message.で始まる場合は分解して取得
  let keys
  if (path.startsWith('message.')) {
    let current = obj
    keys = path.split('.')
    for (const key of keys) {
      if (current && key in current) {
        current = current[key]
      } else {
        return false
      }
    }
    return current
  } else {
    return obj[path] || path
  }
}

Vue.prototype.$t = (key, ...args) => {
  try {
    const localeMessages = i18n.messages[i18n.locale]
    const existingValue = getNestedValue(localeMessages, key)

    if (typeof key === 'string' && existingValue !== false) {
      const translation = originalT(key, ...args)
      const urlParams = new URLSearchParams(window.location.search)

      if (urlParams.get('i18n_debug') === '1') {
        return translation === key ? key : `"${key}"=>${translation}`
      }

      return typeof translation === 'string' ? translation : key
    } else {
      console.log('Translation key not found:', i18n.locale, key)
      return key
    }
  } catch (error) {
    console.error('Translation error:', error)
    return key
  }
}
const initialState = {
  env: 'product',
  baseURL: '/api/',
  mode: 'default',
  key: '',
  viewData: {}
}

// initialState.baseURL = '/api/'
// initialState.env = 'production'

let queryStr = location.search.slice(1)
let queries = {}
if (queryStr) {
  queryStr.split('&').forEach(function (queryStr) {
    let queryArr = queryStr.split('=')
    queries[queryArr[0]] = queryArr[1]
  })
}

if (location.hostname === 'localhost' || location.port === '8080') {
  initialState.env = 'localhost'
  let subDomain = 'tkssp'
  if (queries.ui === '2') { subDomain = 'dyna' }
  if (queries.ui === '4') { subDomain = 'hills' }
  if (queries.ui === '5') { subDomain = 'pia' }
  if (queries.ui === '6') { subDomain = 'washi' }
  initialState.baseURL = 'https://' + subDomain + '.stgsgs.com/reserve/api/'
}

const keyboardLayoutSet = {
  kana: {
    _meta: {
      'backspace': { func: 'backspace', classes: 'control backspace', width: 65 },
      'space': { key: ' ', text: 'Space', width: 180, classes: 'control space' },
      'accept': { func: 'accept', text: 'Close', classes: 'control featured' }
    },
    default: [
      'ア イ ウ エ オ  ハ ヒ フ ヘ ホ',
      'カ キ ク ケ コ  マ ミ ム メ モ',
      'サ シ ス セ ソ  ヤ ユ ヨ',
      'タ チ ツ テ ト  ラ リ ル レ ロ',
      'ナ ニ ヌ ネ ノ  ワ ヲ ン',
      'ガ ギ グ ゲ ゴ  ザ ジ ズ ゼ ゾ',
      'ダ ヂ ヅ デ ド  バ ビ ブ ベ ボ',
      'パ ピ プ ペ ポ  ァ ィ ゥ ェ ォ ャ ュ ョ',
      '{space} {backspace} {accept}'
    ]
  },
  zip: {
    _meta: {
      'backspace': { func: 'backspace', classes: 'control backspace', width: 65 },
      'accept': { func: 'accept', text: 'Close', classes: 'control featured' }
    },
    default: [
      '1 2 3 4 5 6',
      '7 8 9 0 - {backspace} {accept}'
    ]
  },
  phone: {
    _meta: {
      'backspace': { func: 'backspace', classes: 'control backspace', width: 65 },
      'accept': { func: 'accept', text: 'Close', classes: 'control featured' }
    },
    default: [
      '1 2 3 4 5 6 7 8 9 0 -',
      '{backspace} {accept}'
    ]
  },
  email: {
    _meta: {
      'caps': { keySet: 'capsed', text: 'Caps lock', width: 80, classes: 'control' },
      'enter': { key: '\r\n', text: 'Enter', width: 80, classes: 'control' },
      'backspace': { func: 'backspace', classes: 'control backspace', width: 65 },
      'accept': { func: 'accept', text: 'Close', classes: 'control featured' },
      'space': { key: ' ', text: 'Space', width: 180, classes: 'control space' }
    },
    default: [
      '1 2 3 4 5 6 7 8 9 0 - = {backspace}',
      'q w e r t y u i o p [ ] \\',
      'a s d f g h j k l ; \'',
      'z x c v b n m . @',
      '{space} {accept}'
    ]
  },
  normal: {
    _meta: {
      'tab': { key: '\t', text: 'Tab', width: 60, classes: 'control' },
      'shiftl': { keySet: 'shifted', text: 'Shift', width: 100, classes: 'control' },
      'shiftr': { keySet: 'shifted', text: 'Shift', width: 100, classes: 'control' },
      'caps': { keySet: 'capsed', text: 'Caps lock', width: 80, classes: 'control' },
      'space': { key: ' ', text: 'Space', width: 180, classes: 'control space' },
      'enter': { key: '\r\n', text: 'Enter', width: 80, classes: 'control' },
      'backspace': { func: 'backspace', classes: 'control backspace', width: 65 },
      'accept': { func: 'accept', text: 'Close', classes: 'control featured' }
    },
    default: [
      '` 1 2 3 4 5 6 7 8 9 0 - = {backspace}',
      'q w e r t y u i o p [ ] \\',
      '{caps} a s d f g h j k l ; \'',
      '{shiftl} z x c v b n m , . / {shiftr}',
      '{space} {accept}'
    ],
    shifted: [
      '~ ! @ # $ % ^ & * ( ) _ + {backspace}',
      'Q W E R T Y U I O P { } |',
      '{caps} A S D F G H J K L : "',
      '{shiftl} Z X C V B N M < > ? {shiftr}',
      '{space} {accept}'
    ],
    capsed: [
      '` 1 2 3 4 5 6 7 8 9 0 - = {backspace}',
      'Q W E R T Y U I O P [ ] \\',
      '{caps} A S D F G H J K L ; \'',
      '{shiftl} Z X C V B N M , . / {shiftr}',
      '{space} {accept}'
    ]
  }
}
Vue.prototype.keyboardLayoutSet = keyboardLayoutSet
window.v = new Vue({
  data () {
    return initialState
  },
  router: router,
  store: store,
  i18n: i18n,
  created () {
    if (this.$route.name && this.$route.name === 'view') {
      this.mode = 'view'
      this.key = this.$route.params.key
    } else {
      // this.$store.commit('initState')
    }
  },
  render: h => h(App)
}).$mount('#app')
